export default __webpack_public_path__ + "static/media/tick-sm.275101e5.svg";